module.exports = __webpack_public_path__ + "static/media/tab_icon.b17d3cad.svg";